import Immutable, { List, Map } from 'immutable';


const EMPTY_FEATURE_COLLECTION = {type: 'FeatureCollection', features: []};

const SET_PAINT_DATA = "SET_PAINT_DATA";
export const setPaintData = (paintLayerID, paintData) => ({
    type: SET_PAINT_DATA,
    paintLayerID,
    paintData,
});

const SET_RETRO_DATA = "SET_RETRO_DATA";
export const setRetroData = (retroLayerID, retroData) => ({
    type: SET_RETRO_DATA,
    retroLayerID,
    retroData,
});

const SET_IS_RETRO_DATA_LOADING = "SET_IS_RETRO_DATA_LOADING";
export const setIsRetroDataLoading = (isRetroLoadingLayerID, isRetroDataLoading) => ({
    type: SET_IS_RETRO_DATA_LOADING,
    isRetroDataLoading,
    isRetroLoadingLayerID,
});

const SET_IS_PAINT_DATA_LOADING = "SET_IS_PAINT_DATA_LOADING";
export const setIsPaintDataLoading = (isPaintDataLoading, isLoadingLayerID) => ({
    type: SET_IS_PAINT_DATA_LOADING,
    isPaintDataLoading,
    isLoadingLayerID,
});

const SET_HANDWORK_DATA = "SET_HANDWORK_DATA";
export const setHandworkData = (handworkLayerID, handworkData) => ({
    type: SET_HANDWORK_DATA,
    handworkLayerID,
    handworkData,
});

const SET_IS_HANDWORK_DATA_LOADING = "SET_IS_HANDWORK_DATA_LOADING";
export const setIsHandworkDataLoading = (isHandworkDataLoading, handworkLoadingID) => ({
    type: SET_IS_HANDWORK_DATA_LOADING,
    isHandworkDataLoading,
    handworkLoadingID,
});

const SET_COMMENTS_DATA = "SET_COMMENTS_DATA";
export const setCommentsData = (commentsLayerID, commentsData) => ({
    type: SET_COMMENTS_DATA,
    commentsLayerID,
    commentsData,
});

const SET_IS_COMMENTS_DATA_LOADING = "SET_IS_COMMENTS_DATA_LOADING";
export const setIsCommentsDataLoading = (isCommentsDataLoading, commentsLoadingID) => ({
    type: SET_IS_COMMENTS_DATA_LOADING,
    isCommentsDataLoading,
    commentsLoadingID,
});

const initState = Immutable.fromJS({});



const mapDataReducer = (state=initState, action) => {
    switch(action.type){
        // this is also a case in the other reducer
        case 'DELETE_LAYER':
            const deleteMapId = action.mapLayerID;
            let del_state = state.delete(deleteMapId);
            return del_state;

        case SET_COMMENTS_DATA: 
            const { commentsLayerID, commentsData } = action; 
            return state.setIn([commentsLayerID, 'comments'], commentsData);

        case SET_IS_COMMENTS_DATA_LOADING: 
            const {isCommentsDataLoading, commentsLoadingID} = action; 
            let commentsState = state.setIn(
                [commentsLoadingID, 'isCommentsDataLoading'], isCommentsDataLoading
            );
            if (isCommentsDataLoading) {
                commentsState = commentsState.setIn(
                    [commentsLoadingID, 'comments'], []
                );
            }
            return commentsState;

        case SET_HANDWORK_DATA: 
            const { handworkLayerID, handworkData } = action; 
            return state.setIn([handworkLayerID, 'handwork'], handworkData);

        case SET_IS_HANDWORK_DATA_LOADING: 
            const {isHandworkDataLoading, handworkLoadingID} = action; 
            let handworkState = state.setIn(
                [handworkLoadingID, 'isHandworkDataLoading'], isHandworkDataLoading
            );
            if (isHandworkDataLoading) {
                handworkState = handworkState.setIn(
                    [handworkLoadingID, 'handwork'], EMPTY_FEATURE_COLLECTION
                );
            }
            return handworkState;

        case SET_IS_RETRO_DATA_LOADING: 
            const {isRetroDataLoading, isRetroLoadingLayerID} = action; 
            let _retroState = state.setIn([isRetroLoadingLayerID, 'isRetroDataLoading'], isRetroDataLoading);
            if (isRetroDataLoading) {
                _retroState = _retroState.setIn([isRetroLoadingLayerID, 'retro'], EMPTY_FEATURE_COLLECTION);
            }
            console.log('_retroState', _retroState.toJS());
            return _retroState;

        case SET_RETRO_DATA: 
            const { retroLayerID, retroData } = action; 
            return state.setIn([retroLayerID, 'retro'], retroData);

        case SET_PAINT_DATA: 
            const { paintLayerID, paintData } = action; 
            return state.setIn([paintLayerID, 'paint'], paintData);

            // this is the action type thrown when the map is clicked on selecting a
            // job 
        case 'SELECT_JOB':
            const {jobMapLayerID} = action; 
            let __state = state.setIn([jobMapLayerID, 'isPaintDataLoading'], true);
            return __state.setIn([jobMapLayerID, 'paint'], EMPTY_FEATURE_COLLECTION);

        case SET_IS_PAINT_DATA_LOADING: 
            const {isPaintDataLoading, isLoadingLayerID} = action; 
            let _state = state.setIn([isLoadingLayerID, 'isPaintDataLoading'], isPaintDataLoading);
            if (isPaintDataLoading) {
                _state = _state.setIn([isLoadingLayerID, 'paint'], EMPTY_FEATURE_COLLECTION);
            }
            return _state;


        default: 
            return state;
    }
};


export default mapDataReducer;
